import { MouseEventHandler, ReactNode } from "react";
import { ActionIcon } from "@mantine/core";
import {
  CollapsibleWidthComponent,
  TransitionableComponentProps,
} from "./CollapsibleComponent";
import classes from "./CollapsibleActionIcon.module.css";

interface CollapsibleActionIconProps {
  isOpen: TransitionableComponentProps["isOpen"];
  children: ReactNode;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  active?: boolean;
}

export const CollapsibleTopMenuActionIcon = ({
  children,
  isOpen,
  disabled,
  onClick,
  active,
}: CollapsibleActionIconProps) => {
  return (
    <CollapsibleWidthComponent height={28} width={28} isOpen={isOpen}>
      <ActionIcon
        variant="light"
        disabled={disabled}
        onClick={onClick}
        className={classes.icon}
        mod={{ active }}
      >
        {children}
      </ActionIcon>
    </CollapsibleWidthComponent>
  );
};
